import { Component, NgZone, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SettingsProvider } from "../providers/settings/settings";
import { SpecialsPage } from "../pages/specials/specials";
import { ManagedashboardPage } from "../pages/managedashboard/managedashboard";
import { HomePage } from "../pages/home/home";
import { WelcomePage } from "../pages/welcome/welcome";
import { SettingsPage } from "../pages/settings/settings";
import { RestaurentserversPage } from "../pages/restaurentservers/restaurentservers";
import { LoginServiceProvider } from "../providers/authservice/loginService";
import { AuthProvider } from "../providers/authservice/auth";
import { SpiltPanelProvider } from "../providers/spilt-panel/spilt-panel";
import { WaiterDashboardPage } from "../pages/waiter-dashboard/waiter-dashboard";
// import firebase from 'firebase';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  selectedTheme: String;
  isToggled: boolean = true;
  rootPage: any = WelcomePage;
  userObj: any = null;
  zone: NgZone;
  canLoad: boolean = false;
  pages: Array<{ title: string, component: any }>;
  isMenuLoaded = false;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private settings: SettingsProvider, public loginservice: LoginServiceProvider, public authProvider: AuthProvider, public splitPan: SpiltPanelProvider, ) {

    this.isMenuLoaded = false;
    let user = JSON.parse(localStorage.getItem('UserId'));
    this.userObj = JSON.parse(localStorage.getItem('UserObj'));
    console.log(this.userObj);
    console.log(user);
    this.settings.getActiveTheme().subscribe((val) => {
      this.selectedTheme = val;
    });
    if (this.userObj != null && this.userObj.clientId != null && this.userObj.clientId.length > 0) {
      this.pages = [
        { title: 'Dashboard', component: HomePage },
        { title: 'Manage Dashboard', component: ManagedashboardPage },
        { title: 'Specials', component: SpecialsPage },
        { title: 'Servers', component: RestaurentserversPage },
        { title: 'Settings', component: SettingsPage },
        { title: 'Logout', component: WelcomePage },
      ];

    }
    else if (this.userObj != null && this.userObj.waiterTo != null && this.userObj.waiterTo.length > 0) {
      if (this.userObj.waiterTo != '-1') {
        this.pages = [
          { title: 'Dashboard', component: WaiterDashboardPage },
          { title: 'Restaurant', component: HomePage },
          { title: 'Settings', component: SettingsPage },
          { title: 'Logout', component: WelcomePage },

        ];
      }
      else {
        this.pages = [
          { title: 'Dashboard', component: WaiterDashboardPage },
          { title: 'Specials', component: SpecialsPage },
          { title: 'Settings', component: SettingsPage },
          { title: 'Logout', component: WelcomePage },

        ];
      }

    }
    else if (this.userObj != null) {
      this.pages = [
        { title: 'Home', component: WelcomePage },
        { title: 'Logout', component: WelcomePage },
      ];
    }
    /* else {
       this.pages = [
         { title: 'Home', component: WelcomePage }]
         
     }*/
    this.isMenuLoaded = true;
    console.log(this.userObj);
    console.log(this.pages);
    platform.ready().then(() => {



      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      // this.zone=new NgZone({});
      // const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      //   this.zone.run( () => {
      //     if (!user) {
      //       this.rootPage =WelcomePage;
      //       unsubscribe();
      //     } else {
      //       this.rootPage = HomePage;
      //       unsubscribe();
      //     }
      //   });
      // });

    });
  }
  // Setting App theme
  // setTheme() {
  //   if (this.isToggled) {
  //     this.settings.setActiveTheme('dark-theme');
  //     console.log(this.selectedTheme);
  //     this.isToggled = false;
  //   }
  //   else {
  //     this.settings.setActiveTheme('lite-theme');
  //     this.isToggled = true;
  //   }
  // }

  // Navigation Root
  openPage(page) {
    if (page.title == 'Logout') {
      localStorage.removeItem('UserId');
      localStorage.removeItem('UserObj');
      localStorage.removeItem('chktok');
      this.loginservice.logOut();
      this.nav.setRoot(WelcomePage);
    } else {
      this.nav.setRoot(page.component);
    }
  }
  ionViewDidLoad() {
  }
  // Logout
  logOut() {

  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts